export const dateToString = (date) => {
  var days = ["Søndag","Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag","​​Lørdag"];
  var curr_date = date.getDate();
  var curr_month = date.getMonth()+1;
  var curr_year = date.getFullYear();
  return days[date.getDay()] + " d." + curr_date + "/" + curr_month + " " + curr_year;
}


// WEBPACK FOOTER //
// ./src/App/Util/dateToString.js